
export default function Pricing() {
  const includes = [
    '20 short-form daily emails per month',
    'Industry-specific content for fire protection',
    'Compliance-smart messaging',
    'Personality-driven writing',
    'Delivered ready-to-send',
  ];

  const nots = [
    'No tiers.',
    'No confusion.',
    'No "custom proposal."',
  ];

  return (
    <section id="pricing" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Pricing Structure
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            One package. Everything you need. Nothing you don't.
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-gray-900 text-white rounded-lg overflow-hidden shadow-xl">

            {/* Price Header */}
            <div className="p-12 text-center border-b border-gray-800">
              <p className="text-sm uppercase tracking-widest text-red-400 font-semibold mb-4">One Package</p>
              <div className="flex items-end justify-center gap-2 mb-4">
                <div className="flex flex-col items-center">
                  <span className="text-3xl font-semibold text-gray-500 line-through mb-1">$750</span>
                  <span className="text-7xl font-bold text-white">$499</span>
                </div>
                <span className="text-2xl text-gray-400 mb-3">/mo</span>
              </div>
              <p className="text-gray-400 text-lg">Less than one small service call per month.</p>
            </div>

            {/* Includes */}
            <div className="p-12">
              <h4 className="text-sm uppercase tracking-widest text-gray-400 font-semibold mb-6">What's Included</h4>
              <ul className="space-y-4 mb-12">
                {includes.map((item, index) => (
                  <li key={index} className="flex items-center gap-4">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <i className="ri-check-line text-xl text-red-400"></i>
                    </div>
                    <span className="text-lg text-gray-200">{item}</span>
                  </li>
                ))}
              </ul>

              {/* No tiers block */}
              <div className="border-t border-gray-800 pt-8 space-y-3">
                {nots.map((line, index) => (
                  <p key={index} className="text-gray-400 text-lg font-medium">{line}</p>
                ))}
              </div>

              {/* Terms */}
              <div className="mt-8 border-t border-gray-800 pt-8 flex flex-col sm:flex-row gap-6 text-sm text-gray-500">
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-close-line text-gray-600"></i>
                  </div>
                  <span>No hourly billing</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-close-line text-gray-600"></i>
                  </div>
                  <span>No long-term contracts</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-close-line text-gray-600"></i>
                  </div>
                  <span>Max 3-month commitment</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-lg text-gray-600 mb-6">
              Consistent communication pays for itself through retained customers and increased service agreements.
            </p>
            <button
              type="button"
              onClick={() => {
                const element = document.getElementById('final-cta');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-red-600 text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a Strategy Call
            </button>
          </div>

          {/* Skip the call — just sign up */}
          <div className="mt-10 text-center border-t border-gray-200 pt-10">
            <p className="text-gray-500 text-base italic mb-4">
              This sounds pretty straightforward. I don't have time for a strategy call.
            </p>
            <p className="text-gray-800 text-lg font-semibold mb-6">
              Can I just sign up now?
            </p>
            <a
              href="https://buy.stripe.com/9B69AVgGI0a09EL6kUdUY00"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gray-900 text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-lg"></i>
              </div>
              Yes, Sign Me Up — $499/mo
            </a>
            <p className="text-sm text-gray-400 mt-4">Secure checkout via Stripe. Cancel anytime.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
